import * as localForage from 'localforage';

type LocalForageLike = typeof localForage;
type LocalForageNamespace = LocalForageLike & { default?: LocalForageLike };

const localForageModule = localForage as LocalForageNamespace;
const localForageRoot = localForageModule.default ?? localForageModule;

export const appLocalForage = localForageRoot.createInstance({
    name: 'FixedAssets',
    version: 1,
    storeName: 'abpzerotemplate_local_storage',
    description: 'Cached data for FixedAssets',
});
